import React from "react";
import ReactDOM from "react-dom";
import ReactSound from "../Components/general/react/ReactSound";
import ReactCaption from "../Components/general/react/ReactCaption";
import SoundProps from "../Misc/SoundProps";
import Tools from "../Misc/Tools";
import SoundManager from "./SoundManager";

export default class ReactSoundManager extends SoundManager {
	constructor() {
		super();
	}

	protected onAppendSoundToDOM(sound: SoundProps): React.FunctionComponentElement<SoundProps> {
		return React.createElement(ReactSound, { ...sound, key: Tools.generateGuid() } as any);
	}

	render() {
		return (
			<>
				<ReactCaption
					currentCaption={this.ccManager.currentCaption}
				></ReactCaption>
			</>
		);
	}
}